module.exports = __webpack_public_path__ + "static/media/udayy.69c4b890.png";